<template>
  <div class="flex post-preview flex-col cursor-pointer">
    <img :src="require('@/assets/images/blog/' + text.id + '/' + text.preview)" class="w-145 h-100" alt="">
    <div class="flex gap-10">
      <img src="@/assets/images/news_arrow.svg" class="w-5 h-5 mt-16.25" alt="">
      <div class="flex flex-col">
        <p class="date font-medium fz-10 mb-5 mt-7.5" style="color:rgba(110, 117, 141, 1); line-height: 1;letter-spacing: 0.3rem">
          {{ text.date }}</p>
        <h3 class="title fz-20 mb-7.5" style="line-height: 1.5; color: rgba(192, 197, 216, 1)">
          {{ text.title }}
        </h3>
        <div class="tags flex">
          <p class="posts-topic cursor-pointer font-semibold fz-13 uppercase py-2 px-4 rounded-full border " v-for="(item, index) in text.tags" :key="item" :class="{'mr-4': index !== text.tags.length-1}">
            {{ item }}
          </p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "postPreview",
  props:['text']
};
</script>

<style lang="scss" scoped>
.image img, svg{
  transition: all linear .3s;

}
svg{
  transform: rotate(-90deg);
  path{
    stroke: #323749;
    transition: all linear .3s;
  }
}
.post-preview:hover{

  .image img{
    transform: scale(1.2);
  }
  svg{
    path{
      stroke: white;
    }
    transform: rotate(-90deg) translateY(453%);
  }

}
</style>
